<!--
<template>
  <div>
    <b-row class="match-height">
      <b-col
          xl="2"
          md="4"
          sm="6"
      >
        <b-card no-body>
          <b-card-body class="d-flex justify-content-between align-items-center p-1">
            <div class="truncate">
              <h3 v-if="loading3" class="mb-25 font-weight-bolder">
                <b-spinner type="grow" label="Loading..." variant="primary"/>
              </h3>
              <h3 v-else class="mb-25 font-weight-bolder">
                {{c_total}}
              </h3>
              <span>Total</span><br>
              <b-badge variant="primary" class="mt-1 font-small-4 font-weight-bolder">
                {{c_total_d}}
              </b-badge>
            </div>
            <b-avatar
                variant="light-primary"
                size="45"
            >
              <feather-icon
                  size="21"
                  icon="UsersIcon"
              />
            </b-avatar>
          </b-card-body>
        </b-card>
      </b-col>
      <b-col
          xl="2"
          md="4"
          sm="6"
      >
        <b-card no-body>
          <b-card-body class="d-flex justify-content-between align-items-center p-1">
            <div class="truncate">
              <h3 v-if="loading3" class="mb-25 font-weight-bolder">
                <b-spinner type="grow" label="Loading..." variant="secondary"/>
              </h3>
              <h3 v-else class="mb-25 font-weight-bolder">
                {{c_total_p}}
              </h3>
              <span>Pendientes</span><br>
              <b-badge variant="secondary" class="mt-1 font-small-4 font-weight-bolder">
                {{c_total_p_d}}
              </b-badge>
            </div>
            <b-avatar
                variant="light-secondary"
                size="45"
            >
              <feather-icon
                  size="21"
                  icon="ClockIcon"
              />
            </b-avatar>
          </b-card-body>
        </b-card>
      </b-col>
      <b-col
          xl="2"
          md="4"
          sm="6"
      >
        <b-card no-body>
          <b-card-body class="d-flex justify-content-between align-items-center p-1">
            <div class="truncate">
              <h3 v-if="loading3" class="mb-25 font-weight-bolder">
                <b-spinner type="grow" label="Loading..." variant="info"/>
              </h3>
              <h3 v-else class="mb-25 font-weight-bolder">
                {{c_total_pa}}
              </h3>
              <span>Por Abonar</span><br>
              <b-badge variant="info" class="mt-1 font-small-4 font-weight-bolder">
                {{c_total_pa_d}}
              </b-badge>
            </div>
            <b-avatar
                variant="light-info"
                size="45"
            >
              <feather-icon
                  size="21"
                  icon="UserCheckIcon"
              />
            </b-avatar>
          </b-card-body>
        </b-card>
      </b-col>
      <b-col
          xl="2"
          md="4"
          sm="6"
      >
        <b-card no-body>
          <b-card-body class="d-flex justify-content-between align-items-center p-1">
            <div class="truncate">
              <h3 v-if="loading3" class="mb-25 font-weight-bolder">
                <b-spinner type="grow" label="Loading..." variant="success"/>
              </h3>
              <h3 v-else  class="mb-25 font-weight-bolder">
                {{c_total_a}}
              </h3>
              <span>Abonados</span><br>
              <b-badge variant="success" class="mt-1 font-small-4 font-weight-bolder">
                {{c_total_a_d}}
              </b-badge>
            </div>
            <b-avatar
                variant="light-success"
                size="45"
            >
              <feather-icon
                  size="21"
                  icon="DollarSignIcon"
              />
            </b-avatar>
          </b-card-body>
        </b-card>
      </b-col>
      <b-col
          xl="2"
          md="4"
          sm="6"
      >
        <b-card no-body>
          <b-card-body class="d-flex justify-content-between align-items-center p-1">
            <div class="truncate">
              <h3 v-if="loading3" class="mb-25 font-weight-bolder">
                <b-spinner type="grow" label="Loading..." variant="danger"/>
              </h3>
              <h3 v-else  class="mb-25 font-weight-bolder">
                {{c_total_e}}
              </h3>
              <span>Errores</span><br>
              <b-badge variant="danger" class="mt-1 font-small-4 font-weight-bolder">
                {{c_total_e_d}}
              </b-badge>
            </div>
            <b-avatar
                variant="light-danger"
                size="45"
            >
              <feather-icon
                  size="21"
                  icon="XIcon"
              />
            </b-avatar>
          </b-card-body>
        </b-card>
      </b-col>
      <b-col
          xl="2"
          md="4"
          sm="6"
      >
        <b-card no-body>
          <b-card-body class="d-flex justify-content-between align-items-center p-1">
            <div class="truncate">
              <h3 v-if="loading3" class="mb-25 font-weight-bolder">
                <b-spinner type="grow" label="Loading..." variant="warning"/>
              </h3>
              <h3 v-else  class="mb-25 font-weight-bolder">
                {{c_total_c}}
              </h3>
              <span>N° Celular</span>
            </div>
            <b-avatar
                variant="light-warning"
                size="45"
            >
              <feather-icon
                  size="21"
                  icon="PhoneIcon"
              />
            </b-avatar>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>

    <b-row  class="match-height">
      <b-col
          xl="6"
          lg="12"
          md="12"
          sm="12"
      >
        <b-card no-body>
          <b-card-header>
            <b-card-title>Importar</b-card-title>
            <feather-icon
                icon="LogInIcon"
                size="18"
                class="text-muted cursor-pointer"
            />
          </b-card-header>

          <b-card-body v-if="!loading">
            <b-row>
              <b-col md="12">
                <label>Cargar Archivo:</label>
                <b-input-group>
                  <b-form-file
                      id="file-small"
                      accept=".xlsx"
                      placeholder="Seleccionar Archivo Excel (.xlsx)"
                      v-model="archivo_excel"
                      ref="fileinput"
                  >
                    <template
                        slot="file-name"
                        slot-scope="{ names }"
                    >
                      <b-badge variant="primary">
                        {{ names[0] }}
                      </b-badge>
                    </template>
                  </b-form-file>
                  <b-input-group-append>
                    <b-button
                        variant="gradient-secondary"
                        :disabled="!archivo_excel"
                        @click="$refs.fileinput.reset()"
                    >
                      <span>Limpiar</span>
                    </b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-col>

              <b-col md="12" class="mt-1">
                <b-button
                    block
                    variant="gradient-primary"
                    :disabled="!archivo_excel"
                    @click="enviarFile"
                >
                  Importar
                </b-button>
              </b-col>
            </b-row>
          </b-card-body>

          <b-card-body v-if="loading" class="">
            <div class="text-center">
              <b-spinner style="width: 35px; height: 35px;" />
              <p>&emsp;</p>
              <p v-if="">Cargando datos ...</p>
              <p v-if="">Espere un momento ...</p>
              <p v-if="">No cierre la página hasta que termine el proceso ...</p>
            </div>
          </b-card-body>

        </b-card>
      </b-col>
      <b-col
          xl="6"
          lg="12"
          md="12"
          sm="12"
      >
        <b-card no-body>
          <b-card-header>
            <b-card-title>Exportar</b-card-title>
            <feather-icon
                icon="DownloadIcon"
                size="18"
                class="text-muted cursor-pointer"
            />
          </b-card-header>

          <b-card-body>
            <b-row>
              <b-col md="6">
                <b-form-group
                    label="Bancos:"
                    label-for="banco"
                    invalid-feedback="Seleccione banco"
                >
                  <v-select
                      id="banco"
                      v-model="bancoSelected"
                      :options="bancos"
                      placeholder="Seleccionar banco..."
                      required
                  />
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group
                    label="Estados:"
                    label-for="estado"
                    invalid-feedback="Seleccione estado"
                >
                  <v-select
                      id="estado"
                      v-model="estadoSelected"
                      :options="estados"
                      :reduce="estados => estados.value"
                      label="text"
                      key="value"
                      placeholder="Seleccionar estado..."
                      required
                  />
                </b-form-group>
              </b-col>
              <b-col md="12">
                <b-button
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    block
                    variant="primary"
                    @click="descargarFile"
                >
                  <span v-if="loading2"> Generando..&emsp;<b-spinner style="width: 16px; height: 16px;" /></span>
                  <span v-else>Descargar</span>

                </b-button>
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>
      </b-col>
      <b-col
          xl="6"
          lg="12"
          md="12"
          sm="12"
      >
        <b-card no-body>
          <b-card-header>
            <b-card-title>PDF Masivo</b-card-title>
            <feather-icon
                icon="FileTextIcon"
                size="18"
                class="text-muted cursor-pointer"
            />
          </b-card-header>

          <b-card-body>
            <b-row>
              <b-col md="12">
                <p class="text-justify">Descargar las constancias en formato PDF, firmadas por todos los usuarios a los que se le han abonado sus utilidades o están pendiente de abono.</p>
                <div v-if="loading5" class="text-center">
                  <div class="d-flex align-items-center text-center mb-1">
                    <b-spinner/>
                    <span>&emsp;Descargando Archivos ... &emsp13;</span>
                    <span class="font-weight-bold text-body-heading font-weight-bolder mr-1">{{ n_archivo }} / 15</span>
                    <span class="font-weight-bold text-body-heading font-weight-bolder mr-1">|</span>
                    <span class="font-weight-bold text-body-heading font-weight-bolder mr-1">{{ p_archivo }} %</span>
                    <vue-apex-charts
                        type="radialBar"
                        height="30"
                        width="30"
                        :options="options"
                        :series="[p_archivo]"
                    />
                  </div>
                </div>
                <div class="text-left mb-1">
                  <b-list-group v-for="itemn in links_masivos" :key="itemn.archivo">
                    <b-list-group-item class="mb-sm-1"
                                       :href="itemn.link">
                      Archivo número: {{ itemn.archivo }}
                    </b-list-group-item>
                  </b-list-group>
                </div>
                <b-button
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    block
                    variant="primary"
                    @click="traerTotalPdf"
                    :disabled="loading4"
                >
                  <span v-if="loading4"> Generando..&emsp;<b-spinner style="width: 16px; height: 16px;" /></span>
                  <span v-else>Descargar PDF´s</span>

                </b-button>
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>
-->

<!--
<script>
import axiosIns from '../../libs/axios'
import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import VueApexCharts from 'vue-apexcharts'

import {
  BAvatar,
  BBadge,
  BButton,
  BCard,
  BCardBody,
  BCardHeader,
  BCardText,
  BCardTitle,
  BCol,
  BFormFile,
  BFormGroup,
  BInputGroup,
  BInputGroupAppend,
  BRow,
  BSpinner,
  BListGroup,
  BListGroupItem,
} from 'bootstrap-vue'

export default {
  components: {
    BRow,
    BCol,
    BCardText,
    BCard,
    BCardHeader,
    BCardTitle,
    BCardBody,
    BSpinner,
    BFormGroup,

    BInputGroup,
    BFormFile,
    BBadge,
    BInputGroupAppend,
    BButton,
    vSelect,
    ToastificationContent,
    BAvatar,
    VueApexCharts,
    BListGroup, BListGroupItem
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      loading: false,
      loading2: false,
      archivo_excel: null,
      bancos: [
        'Todos',
        'BANCO DE LA NACION',
        'BBVA',
        'BCP',
        'CAJA PIURA',
        'CAJA SULLANA',
        'CAJA TRUJILLO',
        'INTERBANK',
        'SCOTIABANK',
        'Abrir cuenta BCP'
      ],
      estados: [
        {value: '9', text: "Todos"},
        {value: '0', text: "Pendiente"},
        {value: '1', text: "Por abonar"},
        {value: '2', text: "Abonado"},
        {value: '3', text: "Error"}
      ],
      estadoSelected: '9',
      bancoSelected: 'Todos',

      loading3: false,
      loading4: false,
      loading5: false,

      c_total: 0,
      c_total_p: 0,
      c_total_pa: 0,
      c_total_a: 0,
      c_total_e: 0,
      c_total_c: 0,

      c_total_d: 0,
      c_total_p_d: 0,
      c_total_pa_d: 0,
      c_total_a_d: 0,
      c_total_e_d: 0,
      c_total_c_d: 0,
      total_pdf: 0,
      options: { "grid": { "show": false, "padding": { "left": -15, "right": -15, "top": -12, "bottom": -15 } }, "colors": [ "#fba820" ], "plotOptions": { "radialBar": { "hollow": { "size": "22%" }, "track": { "background": "#e9ecef" }, "dataLabels": { "showOn": "always", "name": { "show": false }, "value": { "show": false } } } }, "stroke": { "lineCap": "round" } },

      n_archivo: 0,
      p_archivo: 0,
      links_masivos: []
    }
  },
  computed: {

  },
  mounted() {
    this.traerTotal();
  },
  methods: {
    traerTotal(){
      var yo = this
      yo.loading3 = true

      var config = {
        method: 'get',
        url: '/utilidad/total/'
      };

      axiosIns(config)
          .then(function (response) {
            if(response.status === 200){
              yo.c_total = 0
              yo.c_total_c = 0
              yo.c_total_d = 0
              yo.c_total_c_d = 0
              for (const valuest of response.data){
                if (valuest.estado === '0'){
                  yo.c_total_p = valuest.total.toLocaleString()
                  yo.c_total_p_d = parseFloat(valuest.suma).toLocaleString('es-PE', {style: 'currency', currency: 'PEN'})
                }
                else if (valuest.estado === '1'){
                  yo.c_total_pa = valuest.total.toLocaleString()
                  yo.c_total_pa_d = parseFloat(valuest.suma).toLocaleString('es-PE', {style: 'currency', currency: 'PEN'})
                }
                else if (valuest.estado === '2'){
                  yo.c_total_a = valuest.total.toLocaleString()
                  yo.c_total_a_d = parseFloat(valuest.suma).toLocaleString('es-PE', {style: 'currency', currency: 'PEN'})
                }
                else if (valuest.estado === '3' || valuest.estado === '4'){
                  yo.c_total_e = valuest.total.toLocaleString()
                  yo.c_total_e_d = parseFloat(valuest.suma).toLocaleString('es-PE', {style: 'currency', currency: 'PEN'})
                }

                yo.c_total_c += valuest.celular
                yo.c_total_c_d += parseFloat(valuest.suma)

                yo.c_total += valuest.total
                yo.c_total_d += parseFloat(valuest.suma)
              }

              yo.c_total_c = yo.c_total_c.toLocaleString()
              yo.c_total_c_d = yo.c_total_c_d.toLocaleString('es-PE', {style: 'currency', currency: 'PEN'})

              yo.c_total = yo.c_total.toLocaleString('pe-PE')
              yo.c_total_d = yo.c_total_d.toLocaleString('es-PE', {style: 'currency', currency: 'PEN'})
            }
          })
          .catch(function (error) {
            console.log(error);
          })
          .finally(function (){
            yo.loading3 = false
          });
    },
    traerTotalPdf(){
      var yo = this
      yo.loading4 = true

      var config = {
        method: 'get',
        url: '/utilidad/contarpdfmasivo/'
      };

      axiosIns(config)
          .then(function (response) {
            if(response.status === 200){
              yo.total_pdf = response.data.total
            }
          })
          .catch(function (error) {
            console.log(error);
          })
          .finally(function (){
            yo.loading4 = false
            yo.showMsgBoxTwo()
          });
    },
    enviarFile(){
      var yo = this
      this.loading = true
      var data = new FormData();
      data.append('file', this.archivo_excel)

      var config = {
        method: 'post',
        url: '/archivo/cargar/',
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        data : data
      };

      axiosIns(config)
          .then(function (response) {
            if(response.status === 201){
              yo.$toast({
                component: ToastificationContent,
                props: {
                  title: 'Registro guardado',
                  icon: 'CheckIcon',
                  text: 'El envío de los registros se realizó satisfactoriamente.',
                  variant: 'success',
                },
              })
            }
          })
          .catch(function (error) {
            console.log(error);

            yo.$toast({
              component: ToastificationContent,
              props: {
                title: 'Error en el registro',
                icon: 'XIcon',
                text: 'Hubo un error en el registro, intentelo nuevamente en unos minutos.',
                variant: 'danger',
              },
            })
          })
          .finally(function () {
            yo.archivo_excel = null
            yo.loading = false
          })
      ;

    },
    descargarFile(){
      var yo = this
      this.loading2 = true

      var data = JSON.stringify({
        "banco": yo.bancoSelected,
        "estado": yo.estadoSelected
      });

      var config = {
        method: 'post',
        url: '/archivo/exportar/',
        headers: {
          'Content-Type': 'application/json'
        },
        responseType: 'arraybuffer',
        data : data
      };

      axiosIns(config)
          .then(function (response) {
            if(response.status === 200){
              // window.open(response.data['link'], '_blank')
              console.log("Enviado")

              var fileURL = window.URL.createObjectURL(new Blob([response.data]));
              var fileLink = document.createElement('a');
              fileLink.href = fileURL;
              fileLink.setAttribute('download', 'constancia_utilidade.xlsx');
              document.body.appendChild(fileLink);
              fileLink.click();

              yo.$toast({
                component: ToastificationContent,
                props: {
                  title: 'Archivo creado',
                  icon: 'CheckIcon',
                  text: 'El archivo se creó satisfactoriamente.',
                  variant: 'success',
                },
              })
            }else if(response.status === 204){
              yo.$toast({
                component: ToastificationContent,
                props: {
                  title: 'No existen registros',
                  icon: 'AlertTriangleIcon',
                  text: 'no se encontraron registros con los parámetros solicitados.',
                  variant: 'warning',
                },
              })
            }
          })
          .catch(function (error) {
            console.log(error);
            yo.$toast({
              component: ToastificationContent,
              props: {
                title: 'Error en la creación del archivo',
                icon: 'XIcon',
                text: 'Hubo un error en la creación del archivo, intentelo nuevamente en unos minutos.',
                variant: 'danger',
              },
            })
          })
          .finally(function () {
            yo.bancoSelected = 'Todos'
            yo.estadoSelected = '9'
            yo.loading2 = false
          });

    },
    showMsgBoxTwo() {
      this.boxTwo = ''
      const yo = this;

      const h = this.$createElement
      const sms = h('div', { class: ['font-medium-1'] }, [
        h('p', { class: ['text-justify '] }, [
          'Actualmente se han encontrado ' + this.total_pdf.toLocaleString() + ' registros para descargar su constancia en PDF, por la cantidad de registros se dividirá el proceso para que se descarguen 15 archivos comprimidos de forma individual, por favor no cerrar el navegador hasta que termine el proceso, los archivos se irá descargando a medida que se van generando.',
          h('br'),
          'Tiempo estimado de ejecución: 10 min',
          h('br')
        ]),
        h('p', { class: ['text-right font-weight-bold'] }, [
          '¿Deseas empezar el proceso?'
        ]),
      ])

      this.$bvModal
          .msgBoxConfirm([sms], {
            title: 'Confirmación',
            okVariant: 'primary',
            okTitle: 'DESCARGAR',
            cancelTitle: 'CANCELAR',
            cancelVariant: 'outline-secondary',
            hideHeaderClose: false,
            centered: true,
            noCloseOnBackdrop: true,
            noCloseOnEsc: true
          })
          .then(value => {
            if (value){
              yo.procesoFinal()
            }
          })
    },
    async procesoFinal() {
      var yo = this
      yo.loading4 = true
      yo.loading5 = true
      yo.n_archivo = 0
      yo.p_archivo = 0
      yo.links_masivos = []

      // this.total_pdf = 1000

      const spd = Math.ceil(this.total_pdf / 15);

      for (let i = 1; i <= 15; i++) {

        var config = {
          method: 'get',
          url: '/utilidad/pdfmasivo/?oic=' + i + '&nif=' + spd
        };

        await axiosIns(config)
            .then(function (response) {
              if (response.status === 200) {
                const link = document.createElement('a')
                link.href = response.data.link;
                link.dispatchEvent(new MouseEvent('click'));
                yo.n_archivo = i
                yo.p_archivo = ((i*100)/15).toLocaleString()

                yo.links_masivos.push({"link": response.data.link, "archivo": i})
              }
            })
            .catch(function (error) {
              console.log(error);
            });
      }

      yo.loading4 = false
      yo.loading5 = false

      yo.$toast({
            component: ToastificationContent,
            props: {
              title: 'Archivos creados',
              icon: 'CheckIcon',
              text: 'Los archivos fueron creados y se descargaron satisfactoriamente.',
              variant: 'success',
            },
          },
          {
            position: 'top-center',
          })
    }
  },
}
</script>
-->

<!--
<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
.custom-file-input:lang(en) ~ .custom-file-label::after {
  content: 'Seleccionar';
}
</style>
-->

<template>
  <div>
    <b-row>
      <b-col
          xl="12"
          md="12"
          sm="12"
      >
        <b-card no-body>
          <b-card-body>
            <b-row>
              <b-col md="2">
                <v-select
                    id="banco_f"
                    v-model="anioSelected"
                    :options="anios"
                    :disabled="loadingInicial"
                    placeholder="Seleccionar año..."
                    @input="traerTotal()"
                    :clearable="false"
                    class="select-size-sm"
                />
              </b-col>
              <b-col md="4">
                <v-select
                    id="colaborador"
                    v-model="colaboradorSelected"
                    :options="colaborador"
                    placeholder="Estado colaborador..."
                    @input="changeAnio()"
                    :disabled="loadingInicial"
                    class="select-size-sm"
                />
              </b-col>
              <b-col md="4">
                <v-select
                    id="sociedad"
                    v-model="sociedadSelected"
                    :options="sociedades"
                    placeholder="Sociedad..."
                    @input="changeAnio()"
                    :disabled="loadingInicial"
                    class="select-size-sm"
                />
              </b-col>
              <b-col md="2">
                <b-button
                    id="update"
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    block
                    size="sm"
                    variant="primary"
                    @click="traerTotal()"
                    :disabled="loadingInicial"
                >
                  <span v-if="loadingInicial"> Actualizando..&emsp;<b-spinner style="width: 16px; height: 16px;" /></span>
                  <span v-else>Actualizar</span>

                </b-button>

              </b-col>
            </b-row>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>

    <b-row class="match-height">
      <b-col
          class="text-wrap"
      >
        <b-card no-body>
          <b-card-body class="d-flex justify-content-between align-items-center p-1">
            <div class="truncate">
              <h3 v-if="loadingInicial" class="mb-25 font-weight-bolder">
                <b-spinner type="grow" label="Loading..." variant="primary"/>
              </h3>
              <h3 v-else class="mb-25 font-weight-bolder">
                {{c_total}}
              </h3>
              <span>Colaboradores</span><br>
              <b-badge variant="primary" class="mt-1 mb-1 font-small-4 font-weight-bolder">
                {{c_total_d}}
              </b-badge><br>
              <b class="font-medium-1">{{ c_total_por }} %</b><br>
            </div>
            <b-avatar
                variant="light-primary"
                size="45"
            >
              <feather-icon
                  size="21"
                  icon="UsersIcon"
              />
            </b-avatar>
          </b-card-body>
        </b-card>
      </b-col>
      <b-col
      >
        <b-card no-body>
          <b-card-body class="d-flex justify-content-between align-items-center p-1">
            <div class="truncate">
              <h3 v-if="loadingInicial" class="mb-25 font-weight-bolder">
                <b-spinner type="grow" label="Loading..." variant="success"/>
              </h3>
              <h3 v-else  class="mb-25 font-weight-bolder">
                {{c_total_a}}
              </h3>
              <span>Abonados</span><br>
              <b-badge variant="success" class="mt-1 mb-1 font-small-4 font-weight-bolder">
                {{c_total_a_d}}
              </b-badge><br>
              <b class="font-medium-1">{{ c_total_a_por }} %</b><br>
            </div>
            <b-avatar
                variant="light-success"
                size="45"
            >
              <feather-icon
                  size="21"
                  icon="DollarSignIcon"
              />
            </b-avatar>
          </b-card-body>
        </b-card>
      </b-col>
      <b-col
      >
        <b-card no-body>
          <b-card-body class="d-flex justify-content-between align-items-center p-1">
            <div class="truncate">
              <h3 v-if="loadingInicial" class="mb-25 font-weight-bolder">
                <b-spinner type="grow" label="Loading..." variant="info"/>
              </h3>
              <h3 v-else class="mb-25 font-weight-bolder">
                {{c_total_pa}}
              </h3>
              <span>En Proceso de Abono</span><br>
              <b-badge variant="info" class="mt-1 mb-1 font-small-4 font-weight-bolder">
                {{c_total_pa_d}}
              </b-badge><br>
              <b class="font-medium-1">{{ c_total_pa_por }} %</b><br>
            </div>
            <b-avatar
                variant="light-info"
                size="45"
            >
              <feather-icon
                  size="21"
                  icon="UserCheckIcon"
              />
            </b-avatar>
          </b-card-body>
        </b-card>
      </b-col>
      <b-col
      >
        <b-card no-body>
          <b-card-body class="d-flex justify-content-between align-items-center p-1">
            <div class="truncate">
              <h3 v-if="loadingInicial" class="mb-25 font-weight-bolder">
                <b-spinner type="grow" label="Loading..." variant="secondary"/>
              </h3>
              <h3 v-else class="mb-25 font-weight-bolder">
                {{c_total_p}}
              </h3>
              <span>Pendientes</span><br>
              <b-badge variant="secondary" class="mt-1 mb-1 font-small-4 font-weight-bolder">
                {{c_total_p_d}}
              </b-badge><br>
              <b class="font-medium-1">{{ c_total_p_por }} %</b><br>
            </div>
            <b-avatar
                variant="light-secondary"
                size="45"
            >
              <feather-icon
                  size="21"
                  icon="ClockIcon"
              />
            </b-avatar>
          </b-card-body>
        </b-card>
      </b-col>
      <b-col
      >
        <b-card no-body>
          <b-card-body class="d-flex justify-content-between align-items-center p-1">
            <div class="truncate">
              <h3 v-if="loadingInicial" class="mb-25 font-weight-bolder">
                <b-spinner type="grow" label="Loading..." variant="danger"/>
              </h3>
              <h3 v-else  class="mb-25 font-weight-bolder">
                {{c_total_e}}
              </h3>
              <span>Errores</span><br>
              <b-badge variant="danger" class="mt-1 mb-1 font-small-4 font-weight-bolder">
                {{c_total_e_d}}
              </b-badge><br>
              <b class="font-medium-1">{{ c_total_e_por }} %</b><br>
            </div>
            <b-avatar
                variant="light-danger"
                size="45"
            >
              <feather-icon
                  size="21"
                  icon="XIcon"
              />
            </b-avatar>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>

    <b-row  class="match-height">
      <b-col
          xl="12"
          lg="12"
          md="12"
          sm="12"
      >
        <b-card no-body>
          <b-card-header>
            <b-card-title>Importar</b-card-title>
            <feather-icon
                icon="LogInIcon"
                size="18"
                class="text-muted cursor-pointer"
            />
          </b-card-header>

          <b-card-body v-if="!loading">
            <b-row>
              <b-col md="12">
                <label>Cargar Archivo:</label>
                <b-input-group>
                  <b-form-file
                      id="file-small"
                      accept=".xlsx"
                      placeholder="Seleccionar Archivo Excel (.xlsx)"
                      v-model="archivo_excel"
                      ref="fileinput"
                  >
                    <template
                        slot="file-name"
                        slot-scope="{ names }"
                    >
                      <b-badge variant="primary">
                        {{ names[0] }}
                      </b-badge>
                    </template>
                  </b-form-file>
                  <b-input-group-append>
                    <b-button
                        variant="gradient-secondary"
                        :disabled="!archivo_excel"
                        @click="$refs.fileinput.reset()"
                    >
                      <span>Limpiar</span>
                    </b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-col>

              <b-col md="12" class="mt-1">
                <b-button
                    block
                    variant="gradient-primary"
                    :disabled="!archivo_excel"
                    @click="enviarFile"
                >
                  Importar
                </b-button>
              </b-col>
            </b-row>
          </b-card-body>

          <b-card-body v-if="loading" class="">
            <div class="text-center">
              <b-spinner style="width: 35px; height: 35px;" />
              <p>&emsp;</p>
              <p v-if="">Cargando datos ...</p>
              <p v-if="">Espere un momento ...</p>
              <p v-if="">No cierre la página hasta que termine el proceso ...</p>
            </div>
          </b-card-body>

        </b-card>
      </b-col>
      <b-col
          xl="12"
          lg="12"
          md="12"
          sm="12"
      >
        <b-card no-body>
          <b-card-header>
            <b-card-title>Exportar</b-card-title>
            <feather-icon
                icon="DownloadIcon"
                size="18"
                class="text-muted cursor-pointer"
            />
          </b-card-header>

          <b-card-body>
            <b-row>
              <b-col md="2">
                <b-form-group
                    label="Año:"
                    label-for="anio"
                    invalid-feedback="Seleccione Año"
                >
                  <v-select
                      id="anio"
                      v-model="anioSelectedExp"
                      :options="anios"
                      placeholder="Seleccionar año..."
                      required
                      :clearable="false"
                  />
                </b-form-group>
              </b-col>
              <b-col md="3">
                <b-form-group
                    label="Colaborador:"
                    label-for="colaborador"
                    invalid-feedback="Seleccione Colaborador"
                >
                  <v-select
                      id="colaborador"
                      v-model="colaboradorSelectedExp"
                      :options="colaborador"
                      placeholder="Seleccionar tipo..."
                      required
                      :clearable="false"
                  />
                </b-form-group>
              </b-col>
              <b-col md="3">
                <b-form-group
                    label="Sociedad:"
                    label-for="sociedad"
                    invalid-feedback="Seleccione Sociedad"
                >
                  <v-select
                      id="sociedad"
                      v-model="sociedadSelectedExp"
                      :options="sociedades"
                      placeholder="Seleccionar sociedad..."
                      required
                      :clearable="false"
                  />
                </b-form-group>
              </b-col>
              <b-col md="3">
                <b-form-group
                    label="Bancos:"
                    label-for="banco"
                    invalid-feedback="Seleccione banco"
                >
                  <v-select
                      id="banco"
                      v-model="bancoSelected"
                      :options="bancos"
                      placeholder="Seleccionar banco..."
                      :clearable="false"
                  />
                </b-form-group>
              </b-col>
              <b-col md="2">
                <b-form-group
                    label="Estados:"
                    label-for="estado"
                    invalid-feedback="Seleccione estado"
                >
                  <v-select
                      id="estado"
                      v-model="estadoSelected"
                      :options="estados"
                      :reduce="estados => estados.value"
                      label="text"
                      key="value"
                      placeholder="Seleccionar estado..."
                      :clearable="false"
                  />
                </b-form-group>
              </b-col>
              <b-col md="2">
                <b-form-group
                    label="Inicial Apellido:"
                    label-for="lastname"
                >
                  <b-form-input
                      id="lastname"
                      v-model="lastname"
                      name="lastname"
                  />
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-button
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    block
                    variant="primary"
                    @click="descargarFile"
                    :disabled="loading2 || loading4"
                >
                  <span v-if="loading2"> Generando..&emsp;<b-spinner style="width: 16px; height: 16px;" /></span>
                  <span v-else>Descargar Excel</span>

                </b-button>
              </b-col>
              <b-col md="6">
                <b-button
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    block
                    variant="primary"
                    @click="traerTotalPdf"
                    :disabled="loading4 || loading2"
                >
                  <span v-if="loading4"> Generando..&emsp;<b-spinner style="width: 16px; height: 16px;" /></span>
                  <span v-else>Descargar PDF´s</span>

                </b-button>
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>
      </b-col>

      <!--
      <b-col
          xl="6"
          lg="12"
          md="12"
          sm="12"
      >
        <b-card no-body>
          <b-card-header>
            <b-card-title>PDF Masivo</b-card-title>
            <feather-icon
                icon="FileTextIcon"
                size="18"
                class="text-muted cursor-pointer"
            />
          </b-card-header>

          <b-card-body>
            <b-row>
              <b-col md="12">
                <p class="text-justify">Descargar las constancias en formato PDF, firmadas por todos los usuarios a los que se le han abonado sus utilidades o están pendiente de abono.</p>
                <div v-if="loading5" class="text-center">
                  <div class="d-flex align-items-center text-center mb-1">
                    <b-spinner/>
                    <span>&emsp;Descargando Archivos ... &emsp13;</span>
                    <span class="font-weight-bold text-body-heading font-weight-bolder mr-1">{{ n_archivo }} / 15</span>
                    <span class="font-weight-bold text-body-heading font-weight-bolder mr-1">|</span>
                    <span class="font-weight-bold text-body-heading font-weight-bolder mr-1">{{ p_archivo }} %</span>
                    <vue-apex-charts
                        type="radialBar"
                        height="30"
                        width="30"
                        :options="options"
                        :series="[p_archivo]"
                    />
                  </div>
                </div>
                <div class="text-left mb-1">
                  <b-list-group v-for="itemn in links_masivos" :key="itemn.archivo">
                    <b-list-group-item class="mb-sm-1"
                        :href="itemn.link">
                      Archivo número: {{ itemn.archivo }}
                    </b-list-group-item>
                  </b-list-group>
                </div>
                <b-button
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    block
                    variant="primary"
                    @click="traerTotalPdf"
                    :disabled="loading4"
                >
                  <span v-if="loading4"> Generando..&emsp;<b-spinner style="width: 16px; height: 16px;" /></span>
                  <span v-else>Descargar PDF´s</span>

                </b-button>
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>
      </b-col>
      -->
    </b-row>

    <b-modal
        id="modal_pdf"
        ref="modal_pdf"
        :title="total_pdf>0 ? '¡Confirmación!' : '¡Advertencia!'"
        :ok-title= "total_pdf>0 ? 'DESCARGAR' : 'CERRAR'"
        cancel-title="CANCELAR"
        cancel-variant="outline-secondary"
        hide-header-close
        v-model="estadoModal"
        :cancel-disabled="loading_pdf"
        :ok-disabled="loading_pdf"
        centered
        no-close-on-esc
        no-close-on-backdrop
        @ok="validacionModal"
    >
      <div v-if="loading_pdf" class="text-center font-weight-bold">
        <p class=" font-medium-3">Generando documentos  ... </p>
        <b-spinner label="Loading..." variant="primary"/>
        <br>
        <br>
        <p class=" font-medium-2">No cierres esta ventana hasta que el proceso termine.</p>
      </div>
      <b-row v-else>
        <b-col lg="12" v-if="total_pdf > 0">
          <p class="text-justify font-medium-1">Actualmente se han encontrado {{ total_pdf }} registros para descargar su constancia en PDF, por la cantidad de registros se dividirá el proceso para que se descarguen
            {{  Math.ceil(total_pdf / 200) <= 15 ? Math.ceil(this.total_pdf / 200) : 15   }} archivos comprimidos de forma individual, por favor no cerrar el navegador hasta que termine el proceso, los archivos se irá descargando a medida que se van generando. <br><br>
          Tiempo estimado de ejecución: {{ Math.ceil(this.total_pdf / 200) <= 15 ? Math.ceil(this.total_pdf / 100) : 30 }} min</p>
          <p class="text-right font-weight-bold font-medium-3">¿Deseas iniciar el proceso?</p>
        </b-col>
        <b-col lg="12" v-else>
          <p class="text-justify font-medium-1 font-weight-bold">No se encontraron registros con los parametros ingresados.</p>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
import axiosIns from '../../libs/axios'
import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import VueApexCharts from 'vue-apexcharts'

import {
  BAvatar,
  BBadge,
  BButton,
  BCard,
  BCardBody,
  BCardHeader,
  BCardText,
  BCardTitle,
  BCol,
  BFormInput,
  BFormFile,
  BFormGroup,
  BInputGroup,
  BInputGroupAppend,
  BRow,
  BSpinner,
  BListGroup,
  BListGroupItem,
  BModal,
} from 'bootstrap-vue'

export default {
  components: {
    BRow,
    BCol,
    BCardText,
    BCard,
    BCardHeader,
    BCardTitle,
    BCardBody,
    BSpinner,
    BFormGroup,
    BFormInput,
    BInputGroup,
    BFormFile,
    BBadge,
    BInputGroupAppend,
    BButton,
    BModal,
    vSelect,
    ToastificationContent,
    BAvatar,
    VueApexCharts,
    BListGroup, BListGroupItem
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      loading: false,
      loadingInicial: false,
      loading2: false,
      loading_pdf: false,
      archivo_excel: null,
      bancos: [
        'Todos',
        'BANCO DE LA NACION',
        'BBVA',
        'BCP',
        'CAJA PIURA',
        'CAJA SULLANA',
        'CAJA TRUJILLO',
        'INTERBANK',
        'SCOTIABANK',
        'Abrir cuenta BCP'
      ],
      estados: [
        {value: '9', text: "Todos"},
        {value: '0', text: "Pendiente"},
        {value: '1', text: "En proceso de abono"},
        {value: '2', text: "Abonado"},
        {value: '3', text: "Error"}
      ],
      anios: [],
      colaborador: ['ACTIVO', 'CESADO'],
      colaboradorSelected: null,
      sociedades: [
        { label: "AGROVISION", value: "PE10" },
        { label: "ARENA VERDE", value: "PE20" }
      ],
      sociedadSelected: null,
      colaboradorSelectedExp: 'CESADO',
      estadoSelected: '9',
      anioSelected: 0,
      anioSelectedExp: '2021',
      sociedadSelectedExp:null,
      bancoSelected: 'Todos',
      lastname: '',

      loading3: false,
      loading4: false,
      loading5: false,

      c_total: 0,
      c_total_p: 0,
      c_total_pa: 0,
      c_total_a: 0,
      c_total_e: 0,
      c_total_c: 0,

      c_total_d: 0,
      c_total_p_d: 0,
      c_total_pa_d: 0,
      c_total_a_d: 0,
      c_total_e_d: 0,
      c_total_c_d: 0,

      c_total_por: 0,
      c_total_p_por: 0,
      c_total_pa_por: 0,
      c_total_a_por: 0,
      c_total_e_por: 0,


      total_pdf: 0,
      options: { "grid": { "show": false, "padding": { "left": -15, "right": -15, "top": -12, "bottom": -15 } }, "colors": [ "#fba820" ], "plotOptions": { "radialBar": { "hollow": { "size": "22%" }, "track": { "background": "#e9ecef" }, "dataLabels": { "showOn": "always", "name": { "show": false }, "value": { "show": false } } } }, "stroke": { "lineCap": "round" } },

      n_archivo: 0,
      p_archivo: 0,
      links_masivos: [],

      data_total: [],

      resumen: [],
      list_id: [],
      estadoModal: false
    }
  },
  computed: {

  },
  mounted() {
    this.traerTotal();
  },
  methods: {
    traerTotal(){
      const yo = this
      yo.loadingInicial = true
      yo.colaboradorSelected = null

      yo.totalRows = 1
      yo.c_total = 0
      yo.c_total_d = parseFloat('0').toLocaleString('es-PE', {style: 'currency', currency: 'PEN'})
      yo.c_total_p = 0
      yo.c_total_p_d = parseFloat('0').toLocaleString('es-PE', {style: 'currency', currency: 'PEN'})
      yo.c_total_pa = 0
      yo.c_total_pa_d = parseFloat('0').toLocaleString('es-PE', {style: 'currency', currency: 'PEN'})
      yo.c_total_a = 0
      yo.c_total_a_d = parseFloat('0').toLocaleString('es-PE', {style: 'currency', currency: 'PEN'})
      yo.c_total_e = 0
      yo.c_total_e_d = parseFloat('0').toLocaleString('es-PE', {style: 'currency', currency: 'PEN'})

      yo.c_total_por = 0
      yo.c_total_p_por = 0
      yo.c_total_pa_por = 0
      yo.c_total_a_por = 0
      yo.c_total_e_por = 0

      const data = JSON.stringify(
          {
            "anio": yo.anioSelected
          })

      const config = {
        method: 'post',
        url: '/utilidades/sedadilitu/resumen/n/',
        headers: {
          'Content-Type': 'application/json'
        },
        data : data
      };

      axiosIns(config)
          .then(function (response) {
            if(response.status === 200){

              yo.anios = response.data['anios']
              yo.anioSelected = response.data['anio']
              yo.anioSelectedExp = response.data['anio']
              yo.resumen = response.data['resumen'];

              const agrupado = response.data['resumen'].reduce((result, item) => {
                const estado = item.estado;
                result[estado] = result[estado] || { total_cantidad: 0, total_uti: 0 };
                result[estado].total_cantidad += item.total_cantidad;
                result[estado].total_uti += item.total_uti;

                result.total_cantidad += item.total_cantidad;
                result.total_uti += item.total_uti;
                return result;
              }, {total_cantidad: 0, total_uti: 0});


              yo.c_total = agrupado['total_cantidad'].toLocaleString('pe-PE', {minimumFractionDigits: 0})
              yo.c_total_d = agrupado['total_uti'].toLocaleString('es-PE', {style: 'currency', currency: 'PEN'})
              yo.c_total_p = '0' in agrupado ? agrupado['0']['total_cantidad'].toLocaleString('pe-PE', {minimumFractionDigits: 0}) : yo.c_total_p;
              yo.c_total_p_d = '0' in agrupado ? agrupado['0']['total_uti'].toLocaleString('es-PE', {style: 'currency', currency: 'PEN'}) : yo.c_total_p_d;
              yo.c_total_pa = '1' in agrupado ? agrupado['1']['total_cantidad'].toLocaleString('pe-PE', {minimumFractionDigits: 0}) : yo.c_total_pa;
              yo.c_total_pa_d = '1' in agrupado ? agrupado['1']['total_uti'].toLocaleString('es-PE', {style: 'currency', currency: 'PEN'}) : yo.c_total_pa_d;
              yo.c_total_a = '2' in agrupado ? agrupado['2']['total_cantidad'].toLocaleString('pe-PE', {minimumFractionDigits: 0}) : yo.c_total_a;
              yo.c_total_a_d = '2' in agrupado ? agrupado['2']['total_uti'].toLocaleString('es-PE', {style: 'currency', currency: 'PEN'}) : yo.c_total_a_d;
              yo.c_total_e = '3' in agrupado ? agrupado['3']['total_cantidad'].toLocaleString('pe-PE', {minimumFractionDigits: 0}) : yo.c_total_e;
              yo.c_total_e_d = '3' in agrupado ? agrupado['3']['total_uti'].toLocaleString('es-PE', {style: 'currency', currency: 'PEN'}) : yo.c_total_e_d;


              yo.c_total_por = (isNaN(agrupado['total_uti'] / agrupado['total_uti']) ? 0 : agrupado['total_uti'] / agrupado['total_uti'] * 100).toLocaleString('pe-PE', {maximumFractionDigits: 2})
              yo.c_total_a_por = '2' in agrupado ? (isNaN(parseInt(agrupado['2']['total_uti']) / parseInt(agrupado['total_uti'])) ? 0 : parseInt(agrupado['2']['total_uti']) / parseInt(agrupado['total_uti']) * 100).toLocaleString('pe-PE', {maximumFractionDigits: 2}) : (isNaN(parseInt( yo.c_total_a_d) / parseInt(agrupado['total_uti'])) ? 0 : parseInt( yo.c_total_a_d) / parseInt(agrupado['total_uti']) * 100).toLocaleString('pe-PE', {maximumFractionDigits: 2})
              yo.c_total_p_por = '0' in agrupado ? (isNaN(parseInt(agrupado['0']['total_uti']) / parseInt(agrupado['total_uti'])) ? 0 : parseInt(agrupado['0']['total_uti']) / parseInt(agrupado['total_uti']) * 100).toLocaleString('pe-PE', {maximumFractionDigits: 2}) : (isNaN(parseInt( yo.c_total_p_d) / parseInt(agrupado['total_uti'])) ? 0 : parseInt( yo.c_total_p_d) / parseInt(agrupado['total_uti']) * 100).toLocaleString('pe-PE', {maximumFractionDigits: 2})
              yo.c_total_pa_por = '1' in agrupado ? (isNaN(parseInt(agrupado['1']['total_uti']) / parseInt(agrupado['total_uti'])) ? 0 : parseInt(agrupado['1']['total_uti']) / parseInt(agrupado['total_uti']) * 100).toLocaleString('pe-PE', {maximumFractionDigits: 2}) : (isNaN(parseInt( yo.c_total_pa_d) / parseInt(agrupado['total_uti'])) ? 0 : parseInt( yo.c_total_pa_d) / parseInt(agrupado['total_uti']) * 100).toLocaleString('pe-PE', {maximumFractionDigits: 2})
              yo.c_total_e_por = '3' in agrupado ? (isNaN(parseInt(agrupado['3']['total_uti']) / parseInt(agrupado['total_uti'])) ? 0 : parseInt(agrupado['3']['total_uti']) / parseInt(agrupado['total_uti']) * 100).toLocaleString('pe-PE', {maximumFractionDigits: 2}) : (isNaN(parseInt( yo.c_total_e_d) / parseInt(agrupado['total_uti'])) ? 0 : parseInt( yo.c_total_e_d) / parseInt(agrupado['total_uti']) * 100).toLocaleString('pe-PE', {maximumFractionDigits: 2})

            }
          })
          .catch(function (error) {
            yo.loadingInicial = false
            console.log(error);
          })
          .finally(function (){
            yo.loadingInicial = false
            // yo.traerFundos()
          });
    },
    traerTotalPdf(){
      const yo = this
      yo.loading4 = true
      yo.list_id = []
      yo.total_pdf = 0

      const accents = "ÀÁÂÃÄÅàáâãäåÒÓÔÕÕÖØòóôõöøÈÉÊËèéêëðÇçÐÌÍÎÏìíîïÙÚÛÜùúûüÑñŠšŸÿýŽž";
      const accentsOut = "AAAAAAaaaaaaOOOOOOOooooooEEEEeeeeeCcDIIIIiiiiUUUUuuuuNnSsYyyZz";
      yo.lastname = yo.lastname.split('').map(function(char) {
        const i = accents.indexOf(char)
        return i !== -1 ? accentsOut[i] : char;
      }).join('');

      const apellidos = yo.lastname.toUpperCase();

      const data = JSON.stringify({
        'banco': yo.bancoSelected,
        'estado': yo.estadoSelected,
        'anio': yo.anioSelectedExp,
        'colaborador': yo.colaboradorSelectedExp,
        'lastname': apellidos,
        'sociedad': yo.sociedadSelectedExp ? yo.sociedadSelectedExp.value : 'Todos'
      })

      const config = {
        method: 'post',
        url: '/utilidades/utilidad/contarpdfmasivo/',
        headers: {
          'Content-Type': 'application/json'
        },
        data: data
      }

      axiosIns(config)
          .then(function (response) {
            if(response.status === 200){
              yo.list_id = response.data
              yo.total_pdf = yo.list_id.length
              // yo.total_pdf = 3001
            }
          })
          .catch(function (error) {
            console.log(error);
          })
          .finally(function (){
            yo.loading4 = false
            yo.estadoModal = true
          });
    },
    enviarFile(){
      const yo = this
      this.loading = true
      const data = new FormData()
      data.append('file', this.archivo_excel)

      const config = {
        method: 'post',
        url: '/utilidades/archivo/cargar/',
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        data: data
      }

      axiosIns(config)
          .then(function (response) {
            if(response.status === 201){
              yo.$toast({
                component: ToastificationContent,
                props: {
                  title: 'Registro guardado',
                  icon: 'CheckIcon',
                  text: 'El envío de los registros se realizó satisfactoriamente.',
                  variant: 'success',
                },
              },
              {
                timeout: 3000,
                position: 'top-center',
              })
            }
          })
          .catch(function (error) {
            console.log(error);

            yo.$toast({
              component: ToastificationContent,
              props: {
                title: 'Error en el registro',
                icon: 'XIcon',
                text: 'Hubo un error en el registro, intentelo nuevamente en unos minutos.',
                variant: 'danger',
              },
            },
                {
                  timeout: 3000,
                  position: 'top-center',
                })
          })
          .finally(function () {
            yo.archivo_excel = null
            yo.loading = false
          })
      ;

    },
    descargarFile(){
      const yo = this
      this.loading2 = true

      const data = JSON.stringify({
        'banco': yo.bancoSelected,
        'estado': yo.estadoSelected,
        'anio': yo.anioSelectedExp,
        'colaborador': yo.colaboradorSelectedExp,
        'sociedad': yo.sociedadSelectedExp ? yo.sociedadSelectedExp.value : 'Todos'
      })

      const config = {
        method: 'post',
        url: '/utilidades/archivo/exportar/',
        headers: {
          'Content-Type': 'application/json'
        },
        responseType: 'arraybuffer',
        data: data
      }

      axiosIns(config)
          .then(function (response) {
            if(response.status === 200){
              // window.open(response.data['link'], '_blank')

              const fileURL = window.URL.createObjectURL(new Blob([response.data]))
              const fileLink = document.createElement('a')
              fileLink.href = fileURL;
              fileLink.setAttribute('download', 'constancia_utilidade.xlsx');
              document.body.appendChild(fileLink);
              fileLink.click();

              yo.$toast({
                component: ToastificationContent,
                props: {
                  title: 'Archivo creado',
                  icon: 'CheckIcon',
                  text: 'El archivo se creó satisfactoriamente.',
                  variant: 'success',
                },
              },
                  {
                    timeout: 3000,
                    position: 'top-center',
                  })
            }else if(response.status === 204){
              yo.$toast({
                component: ToastificationContent,
                props: {
                  title: 'No existen registros',
                  icon: 'AlertTriangleIcon',
                  text: 'no se encontraron registros con los parámetros solicitados.',
                  variant: 'warning',
                },
              },
                  {
                    timeout: 3000,
                    position: 'top-center',
                  })
            }
          })
          .catch(function (error) {
            console.log(error);
            yo.$toast({
              component: ToastificationContent,
              props: {
                title: 'Error en la creación del archivo',
                icon: 'XIcon',
                text: 'Hubo un error en la creación del archivo, intentelo nuevamente en unos minutos.',
                variant: 'danger',
              },
            },
                {
                  timeout: 3000,
                  position: 'top-center',
                })
          })
          .finally(function () {
            yo.bancoSelected = 'Todos'
            yo.estadoSelected = '9'
            yo.loading2 = false
          });

    },
    showMsgBoxTwo() {
      this.boxTwo = ''
      const yo = this;

      const h = this.$createElement
      let sms = ''

      if(Math.ceil(yo.total_pdf / 200)<=15 && Math.ceil(yo.total_pdf / 200)>0){
        sms = h('div', { class: ['font-medium-1'] }, [
          h('p', { class: ['text-justify '] }, [
            'Actualmente se han encontrado ' + this.total_pdf.toLocaleString() + ' registros para descargar su constancia en PDF, por la cantidad de registros se dividirá el proceso para que se descarguen '+ Math.ceil(yo.total_pdf / 200).toString() +' archivos comprimidos de forma individual, por favor no cerrar el navegador hasta que termine el proceso, los archivos se irá descargando a medida que se van generando.',
            h('br'),
            'Tiempo estimado de ejecución: '+ Math.ceil(yo.total_pdf / 100).toString() +' min',
            h('br')
          ]),
          h('p', { class: ['text-right font-weight-bold'] }, [
            '¿Deseas empezar el proceso?'
          ]),
        ])
      }else if(Math.ceil(yo.total_pdf / 200)>15){
        sms = h('div', { class: ['font-medium-1'] }, [
          h('p', { class: ['text-justify '] }, [
            'Actualmente se han encontrado ' + this.total_pdf.toLocaleString() + ' registros para descargar su constancia en PDF, por la cantidad de registros se dividirá el proceso para que se descarguen 15 archivos comprimidos de forma individual, por favor no cerrar el navegador hasta que termine el proceso, los archivos se irá descargando a medida que se van generando.',
            h('br'),
            'Tiempo estimado de ejecución: 30 min',
            h('br')
          ]),
          h('p', { class: ['text-right font-weight-bold'] }, [
            '¿Deseas empezar el proceso?'
          ]),
        ])
      }else{
        sms = h('div', { class: ['font-medium-1'] }, [
          h('p', { class: ['text-justify '] }, [
            'No se encontraron registros con los parametros ingresados',
            h('br')
          ]),
        ])
      }

      this.$bvModal
          .msgBoxConfirm([sms], {
            title: 'Confirmación',
            okVariant: 'primary',
            okTitle: yo.total_pdf>0 ? 'DESCARGAR' : 'CERRAR',
            cancelTitle: 'CANCELAR',
            cancelVariant: 'outline-secondary',
            hideHeaderClose: false,
            centered: true,
            noCloseOnBackdrop: true,
            noCloseOnEsc: true
          })
          .then(value => {
            if (value && yo.total_pdf>0){
              yo.procesoFinal()
            }
          })
    },

    /*
    async procesoFinal() {
      const yo = this
      yo.loading4 = true
      yo.loading5 = true
      yo.n_archivo = 0
      yo.p_archivo = 0
      yo.links_masivos = []

      const accents = "ÀÁÂÃÄÅàáâãäåÒÓÔÕÕÖØòóôõöøÈÉÊËèéêëðÇçÐÌÍÎÏìíîïÙÚÛÜùúûüÑñŠšŸÿýŽž";
      const accentsOut = "AAAAAAaaaaaaOOOOOOOooooooEEEEeeeeeCcDIIIIiiiiUUUUuuuuNnSsYyyZz";
      yo.lastname = yo.lastname.split('').map(function(char) {
        const i = accents.indexOf(char)
        return i !== -1 ? accentsOut[i] : char;
      }).join('');

      const apellidos = yo.lastname.toUpperCase();

      // this.total_pdf = 1000

      const spd = Math.ceil(this.total_pdf / 15);

      if(this.total_pdf>15){
        for (let i = 1; i <= 15; i++) {

          const config = {
            method: 'get',
            url: '/utilidad/pdfmasivo/?oic=' + i + '&nif=' + spd + '&banco=' + yo.bancoSelected + '&estado=' + yo.estadoSelected + '&anio=' + yo.anioSelectedExp + '&colaborador=' + yo.colaboradorSelectedExp + '&lastname=' + apellidos
          }

          await axiosIns(config)
              .then(function (response) {
                if (response.status === 200) {
                  const link = document.createElement('a')
                  link.href = response.data.link;
                  link.dispatchEvent(new MouseEvent('click'));
                  yo.n_archivo = i
                  yo.p_archivo = ((i*100)/15).toLocaleString()

                  yo.links_masivos.push({"link": response.data.link, "archivo": i})
                }
              })
              .catch(function (error) {
                console.log(error);
              });
        }
      }else{
        const config = {
          method: 'get',
          url: '/utilidad/pdfmasivo/?oic=' + 1 + '&nif=' + this.total_pdf + '&banco=' + yo.bancoSelected + '&estado=' + yo.estadoSelected + '&anio=' + yo.anioSelectedExp + '&colaborador=' + yo.colaboradorSelectedExp + '&lastname=' + apellidos
        }

        await axiosIns(config)
            .then(function (response) {
              if (response.status === 200) {
                const link = document.createElement('a')
                link.href = response.data.link;
                link.dispatchEvent(new MouseEvent('click'));
                yo.n_archivo = 1
                yo.p_archivo = ((100)/15).toLocaleString()

                yo.links_masivos.push({"link": response.data.link, "archivo": 1})
              }
            })
            .catch(function (error) {
              console.log(error);
            });
      }

      yo.loading4 = false
      yo.loading5 = false

      yo.$toast({
        component: ToastificationContent,
        props: {
          title: 'Archivos creados',
          icon: 'CheckIcon',
          text: 'Los archivos fueron creados y se descargaron satisfactoriamente.',
          variant: 'success',
        },
      },
          {
            timeout: 3000,
            position: 'top-center',
          })
    },
    */

    validacionModal(bvModalEvt){
      bvModalEvt.preventDefault()

      if (this.total_pdf > 0){
        this.procesoFinal()
      }else{
        this.$nextTick(() => {
          this.$refs['modal_pdf'].toggle('#toggle-btn')
        })
      }


    },

    async procesoFinal() {

      const yo = this
      yo.loading4 = true
      yo.loading5 = true
      yo.loading_pdf = true
      yo.n_archivo = 0
      yo.p_archivo = 0

      const n_zip_s = Math.ceil(yo.total_pdf / 200);
      const n_pdf_zip_s = Math.ceil(yo.total_pdf / 15);

      const n_zip = n_zip_s <= 15 ? n_zip_s : 15
      const n_pdf_zip = n_pdf_zip_s <= 200 ? 200 : n_pdf_zip_s

      for (let i = 1; i <= n_zip; i++) {

        const a = n_pdf_zip * (i - 1)
        const b = i === n_zip ? yo.total_pdf : n_pdf_zip * i
        const subArrays = yo.list_id.slice(a, b)

        const data = JSON.stringify({
          'ids': subArrays,
          'a': a === 0 ? 1 : a,
          'b': b
        })

        const config = {
          method: 'post',
          url: '/utilidades/utilidad/pdfmasivo/',
          data: data
        }

        await axiosIns(config)
            .then(function (response) {
              if (response.status === 200) {

                const link = document.createElement('a')
                link.href = axiosIns.defaults.baseURL + response.data.link;
                link.dispatchEvent(new MouseEvent('click'));
              }
            })
            .catch(function (error) {
              console.log(error);
            });

      }

      yo.loading4 = false
      yo.loading5 = false
      yo.loading_pdf = false
      yo.estadoModalEditar = false

      yo.$nextTick(() => {
        yo.$refs['modal_pdf'].toggle('#toggle-btn')
      })

      yo.$toast({
        component: ToastificationContent,
        props: {
          title: 'Archivos creados',
          icon: 'CheckIcon',
          text: 'Los archivos fueron creados y se descargaron satisfactoriamente.',
          variant: 'success',
        },
      },
      {
        timeout: 4000,
        position: 'top-center',
      })

    },

    changeAnio() {
      const yo = this

      yo.c_total_por = 0
      yo.c_total_p_por = 0
      yo.c_total_pa_por = 0
      yo.c_total_a_por = 0
      yo.c_total_e_por = 0

      yo.c_total = 0
      yo.c_total_d = parseFloat('0').toLocaleString('es-PE', {style: 'currency', currency: 'PEN'})
      yo.c_total_p = 0
      yo.c_total_p_d = parseFloat('0').toLocaleString('es-PE', {style: 'currency', currency: 'PEN'})
      yo.c_total_pa = 0
      yo.c_total_pa_d = parseFloat('0').toLocaleString('es-PE', {style: 'currency', currency: 'PEN'})
      yo.c_total_a = 0
      yo.c_total_a_d = parseFloat('0').toLocaleString('es-PE', {style: 'currency', currency: 'PEN'})
      yo.c_total_e = 0
      yo.c_total_e_d = parseFloat('0').toLocaleString('es-PE', {style: 'currency', currency: 'PEN'})

      const agrupado = yo.resumen.reduce((result, item) => {
        const estado = item.estado;
        if (yo.colaboradorSelected !== null) {
    // Si hay un colaborador seleccionado
        if (item.estado_empleado === yo.colaboradorSelected) {
          // Filtrar también por sociedad seleccionada
          if (yo.sociedadSelected === null || item.sociedad === yo.sociedadSelected.value) {
            result[estado] = result[estado] || { total_cantidad: 0, total_uti: 0 };
            result[estado].total_cantidad += item.total_cantidad;
            result[estado].total_uti += item.total_uti;

            result.total_cantidad += item.total_cantidad;
            result.total_uti += item.total_uti;
          }
        }
      } else {
        // Si no hay un colaborador seleccionado
        if (yo.sociedadSelected === null || item.sociedad === yo.sociedadSelected.value) {
          result[estado] = result[estado] || { total_cantidad: 0, total_uti: 0 };
          result[estado].total_cantidad += item.total_cantidad;
          result[estado].total_uti += item.total_uti;

          result.total_cantidad += item.total_cantidad;
          result.total_uti += item.total_uti;
        }
      }

        return result;
      }, {total_cantidad: 0, total_uti: 0});


      yo.c_total = agrupado['total_cantidad'].toLocaleString('pe-PE', {minimumFractionDigits: 0})
      yo.c_total_d = agrupado['total_uti'].toLocaleString('es-PE', {style: 'currency', currency: 'PEN'})
      yo.c_total_p = '0' in agrupado ? agrupado['0']['total_cantidad'].toLocaleString('pe-PE', {minimumFractionDigits: 0}) : yo.c_total_p;
      yo.c_total_p_d = '0' in agrupado ? agrupado['0']['total_uti'].toLocaleString('es-PE', {style: 'currency', currency: 'PEN'}) : yo.c_total_p_d;
      yo.c_total_pa = '1' in agrupado ? agrupado['1']['total_cantidad'].toLocaleString('pe-PE', {minimumFractionDigits: 0}) : yo.c_total_pa;
      yo.c_total_pa_d = '1' in agrupado ? agrupado['1']['total_uti'].toLocaleString('es-PE', {style: 'currency', currency: 'PEN'}) : yo.c_total_pa_d;
      yo.c_total_a = '2' in agrupado ? agrupado['2']['total_cantidad'].toLocaleString('pe-PE', {minimumFractionDigits: 0}) : yo.c_total_a;
      yo.c_total_a_d = '2' in agrupado ? agrupado['2']['total_uti'].toLocaleString('es-PE', {style: 'currency', currency: 'PEN'}) : yo.c_total_a_d;
      yo.c_total_e = '3' in agrupado ? agrupado['3']['total_cantidad'].toLocaleString('pe-PE', {minimumFractionDigits: 0}) : yo.c_total_e;
      yo.c_total_e_d = '3' in agrupado ? agrupado['3']['total_uti'].toLocaleString('es-PE', {style: 'currency', currency: 'PEN'}) : yo.c_total_e_d;

      yo.c_total_por = (isNaN(agrupado['total_uti'] / agrupado['total_uti']) ? 0 : agrupado['total_uti'] / agrupado['total_uti'] * 100).toLocaleString('pe-PE', {maximumFractionDigits: 2})
      yo.c_total_a_por = '2' in agrupado ? (isNaN(parseInt(agrupado['2']['total_uti']) / parseInt(agrupado['total_uti'])) ? 0 : parseInt(agrupado['2']['total_uti']) / parseInt(agrupado['total_uti']) * 100).toLocaleString('pe-PE', {maximumFractionDigits: 2}) : (isNaN(parseInt( yo.c_total_a_d) / parseInt(agrupado['total_uti'])) ? 0 : parseInt( yo.c_total_a_d) / parseInt(agrupado['total_uti']) * 100).toLocaleString('pe-PE', {maximumFractionDigits: 2})
      yo.c_total_p_por = '0' in agrupado ? (isNaN(parseInt(agrupado['0']['total_uti']) / parseInt(agrupado['total_uti'])) ? 0 : parseInt(agrupado['0']['total_uti']) / parseInt(agrupado['total_uti']) * 100).toLocaleString('pe-PE', {maximumFractionDigits: 2}) : (isNaN(parseInt( yo.c_total_p_d) / parseInt(agrupado['total_uti'])) ? 0 : parseInt( yo.c_total_p_d) / parseInt(agrupado['total_uti']) * 100).toLocaleString('pe-PE', {maximumFractionDigits: 2})
      yo.c_total_pa_por = '1' in agrupado ? (isNaN(parseInt(agrupado['1']['total_uti']) / parseInt(agrupado['total_uti'])) ? 0 : parseInt(agrupado['1']['total_uti']) / parseInt(agrupado['total_uti']) * 100).toLocaleString('pe-PE', {maximumFractionDigits: 2}) : (isNaN(parseInt( yo.c_total_pa_d) / parseInt(agrupado['total_uti'])) ? 0 : parseInt( yo.c_total_pa_d) / parseInt(agrupado['total_uti']) * 100).toLocaleString('pe-PE', {maximumFractionDigits: 2})
      yo.c_total_e_por = '3' in agrupado ? (isNaN(parseInt(agrupado['3']['total_uti']) / parseInt(agrupado['total_uti'])) ? 0 : parseInt(agrupado['3']['total_uti']) / parseInt(agrupado['total_uti']) * 100).toLocaleString('pe-PE', {maximumFractionDigits: 2}) : (isNaN(parseInt( yo.c_total_e_d) / parseInt(agrupado['total_uti'])) ? 0 : parseInt( yo.c_total_e_d) / parseInt(agrupado['total_uti']) * 100).toLocaleString('pe-PE', {maximumFractionDigits: 2})


    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
.custom-file-input:lang(en) ~ .custom-file-label::after {
  content: 'Seleccionar';
}
.modal-body{
  padding: 0.8rem 1.4rem!important;
}
</style>
